import Config from '../Config';
import moment from 'moment';
import {format_without_time} from '../Utils';
import { RestService } from './RestService';

export const NotificationService = {
    sendNotification: async function(id, title, body){
        return RestService.post(`${Config.send_notification}id=${id}&body=${body}&title=${title}`, {}, body)
        .then((response) => response.json());
    },
    notifyAgentsAboutImport: async function(routeId, date){
        return RestService.get(`${Config.notify_user_schedules_ready}routeId=${routeId}&import_date=${moment(date).format(format_without_time)}`, {});
    },
    notifyAgentsAboutDeliveryChanges: async function(routeId, date, store_name){
        return RestService.get(`${Config.notify_user_schedule_changes}routeId=${routeId}&import_date=${moment(date).format(format_without_time)}&store_name=${store_name}`, {});
    }
};